const PRODUCTION_HOST = "analyze.nyafaz.com";
const PRODUCTION_API_PATH = "/nyafaz-portal-api";

function isLocalDevHost() {
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}

function isDevBuild() {
  return process.env.NODE_ENV === "development";
}

function normalizeConfiguredBase(configured) {
  if (!configured) return "";
  const c = String(configured).trim().replace(/\/$/, "");
  if (!isDevBuild()) {
    return c;
  }
  if (c === "http://localhost:5015" || c === "http://127.0.0.1:5015") {
    return PRODUCTION_API_PATH;
  }
  return c;
}

const resolveApiBase = () => {
  if (typeof window !== "undefined") {
    const host = String(window.location.hostname || "").toLowerCase();
    if (host === PRODUCTION_HOST) {
      return PRODUCTION_API_PATH;
    }
  }

  const configured = normalizeConfiguredBase(process.env.REACT_APP_NYAFAZ_PORTAL_API_URL);

  if (isDevBuild() && isLocalDevHost()) {
    if (configured && configured.startsWith("/")) {
      return configured;
    }
    return PRODUCTION_API_PATH;
  }

  if (configured && typeof window !== "undefined") {
    const host = window.location.hostname;
    const pageIsLocal = host === "localhost" || host === "127.0.0.1";
    const configuredIsLocal =
      configured.includes("localhost") || configured.includes("127.0.0.1");
    if (!pageIsLocal && configuredIsLocal) {
      return PRODUCTION_API_PATH;
    }
    return configured;
  }
  if (configured) return configured;
  return PRODUCTION_API_PATH;
};

export function getApiBase() {
  return resolveApiBase();
}

export function portalApiUrl(path) {
  const base = getApiBase().replace(/\/$/, "");
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return `${base}${suffix}`;
}
